// extracted by mini-css-extract-plugin
module.exports = {"inlineBlock":"StatementDescriptor_inlineBlock__33Lig","validationTips":"StatementDescriptor_validationTips__Q_zMu"};